/* eslint-disable import/no-cycle */
import { all, takeLatest, call, put } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '../../../services/api';
import {
  getDocumentRepairLogsSuccess,
  documentRepairLogsFailure,
} from './actions';
import { refreshTokenRequest } from '../auth/actions';
import { store } from '../../index';

export function* getDocumentRepairLogs({ payload }) {
  const { refresh_token } = store.getState().auth;

  try {
    const {
      limit = 10,
      page = 1,
      clientId,
      yourNumber,
      documentType,
      documentFixGroup,
      repairResult,
      initialDate,
      finalDate,
      onSuccess,
    } = payload;

    const response = yield call(
      (url) =>
        api.get(url, {
          params: {
            client_id: clientId,
            your_number: yourNumber,
            document_type: documentType,
            document_fix_group: documentFixGroup,
            repair_result: repairResult,
            initial_date: initialDate,
            final_date: finalDate,
            limit,
            page,
          },
        }),
      '/signature-data/v1/document-repair-log'
    );

    yield put(getDocumentRepairLogsSuccess(response.data));
    if (onSuccess) onSuccess();
  } catch (err) {
    if (err.response.status === 403) {
      yield put(refreshTokenRequest(refresh_token));
    } else {
      yield put(documentRepairLogsFailure());
      toast.error('Falha ao listar registros de reparo');
    }
  }
}

export default all([
  takeLatest('@documentRepairLogs/GET_REQUEST', getDocumentRepairLogs),
]);
